import type { IconData } from '@stacksjs/iconify-core'

export const computerOldElectronicsBug: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.475 22.86h-4.57v-1.53h1.52v-1.52H4.575v1.52H6.1v1.53H1.525V32h28.95Zm-22.86-1.53h16.76v1.53H7.615Zm21.34 9.15H3.045v-6.1h25.91Zm-1.53-28.96h1.53v18.29h-1.53Z\"/><path fill=\"currentColor\" d=\"M22.855 28.95h1.52v-1.52h1.53V25.9h-7.62v1.53h4.57zM19.805 6.1h1.53v1.52h-1.53Zm-9.14 0h1.52v1.52h-1.52Zm10.67 3.04h-1.53V7.62h-7.62v1.52h-1.52v1.53h-1.52v4.57h1.52v-3.05h1.52v3.05h1.53v-1.53h4.57v1.53h1.52v-3.05h1.53v3.05h1.52v-4.57h-1.52Zm-6.1 1.53h-1.52V9.14h1.52Zm3.05 0h-1.52V9.14h1.52Z\"/><path fill=\"currentColor\" d=\"M6.1 18.29h19.81V3.05H6.1ZM7.615 4.57h16.76v12.19H7.615ZM6.095 25.9h1.52v1.53h-1.52ZM4.575 0h22.85v1.52H4.575Zm-1.53 1.52h1.53v18.29h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default computerOldElectronicsBug
